import {createContext} from 'react';

export const RoomTypesListContext = createContext({});
